import { computed } from "@preact/signals"
import AssetKey from "custom/asset_key"
import styled from "@emotion/styled"
import Image from "../base/Image"
import { IndexData } from "@/features_signal/indexData"

const BrandLogoMain = styled(Image)`
    width: 136rem;
    height: 32rem;
    object-fit: contain;
`

type BrandLogoProps = Omit<ExtractStyledProps<typeof BrandLogoMain>, "src">

export default function BrandLogo(props: BrandLogoProps) {
    return (
        <BrandLogoMain
            {...props}
            src={IndexData.dataLogo.value}
        />
    )
}
